import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IMaterialItem } from '../../interfaces/news';

export interface IState {
  list: IMaterialItem[];
}

const initialState: IState = {
  list: [],
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNews(state, { payload }: PayloadAction<IMaterialItem[]>) {
      state.list = payload;
    },
  },
});

const { reducer, actions } = newsSlice;
export const { setNews } = actions;

export default reducer;
